import { useEffect, useState } from 'react';

import { useHistory } from 'react-router-dom';
import _ from 'lodash';

import {
  useDeleteAssignmentMutation,
  useGetTeachersQuizzAssignmentsQuery,
} from '@school_ify/schoolify-repository/src/teacher/types';

import { useAppSelector } from 'redux/hooks';
import { getUser } from 'redux/authentication/auth.slice';
import AssignmentAndEventListCard from 'clean/components/common/AssignmentAndEventListCard/AssignmentAndEventListCard';
import DeleteModal from 'components/DeleteModal/DeleteModal';

import './QuizDashboard.scoped.scss';

const QuizCollection: React.FC = () => {
  const history = useHistory();

  const [groupedQuizzesBySubject, setGroupedQuizzesBySubject] = useState({});
  const [modal, toggleModal] = useState<boolean>(false);
  const [selectedQuiz, setSelectedQuiz] = useState(null);
  const user = useAppSelector(getUser);

  const data = useGetTeachersQuizzAssignmentsQuery({
    variables: {
      user_id: user.id,
    },
    onCompleted: fetchedData => {
      if (fetchedData?.assignments) {
        setGroupedQuizzesBySubject(
          _.groupBy(fetchedData?.assignments, obj => obj.teaching_structure.title)
        );
      }
    },
  });

  const refetchQuizzes = () => {
    data.refetch({ user_id: user.id });
  };

  const [deleteAssignmentByPk] = useDeleteAssignmentMutation();

  const deleteAssignment = () => {
    deleteAssignmentByPk({ variables: { id: selectedQuiz.id }, onCompleted: refetchQuizzes });
    toggleModal(false);
    setSelectedQuiz(null);
  };

  const handleDeleteAssignment = quiz => {
    setSelectedQuiz(quiz);
    toggleModal(true);
  };

  const editAssignment = quiz => {
    history.push(`/quiz/edit/${quiz.id}`);
  };

  const getClassName = elements => {
    let title;

    elements.map(el => {
      title = el.teaching_structure.title;
      return title;
    });

    return title;
  };

  useEffect(() => {
    refetchQuizzes();
  }, []);

  return (
    <div className="quiz-dashboard-container">
      <DeleteModal
        openModal={modal}
        handleModal={() => {
          toggleModal(!modal);
          setSelectedQuiz(null);
        }}
        handleCloseModal={() => {
          toggleModal(!modal);
          setSelectedQuiz(null);
        }}
        generalMessage={selectedQuiz?.title}
        handleDelete={deleteAssignment}
      />
      {Object.keys(groupedQuizzesBySubject).map(key => {
        return (
          <div key={key}>
            <label htmlFor="#" className="text-bold mt-1 flex title">
              {getClassName(groupedQuizzesBySubject[key])}
            </label>
            <div className="quiz-list">
              {groupedQuizzesBySubject[key].map(quiz => {
                return (
                  <AssignmentAndEventListCard
                    key={quiz.id}
                    name={quiz.title}
                    date={quiz.created_at}
                    onEdit={() => editAssignment(quiz)}
                    onDelete={() => handleDeleteAssignment(quiz)}
                  />
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default QuizCollection;
